import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SignUpElement, SignUpType, popSignUp } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { AnimatedWordPerfect, BannerContentTypography, RotatingLink } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/BottomSignUpBannerStyles";
import { useGetBottomSignUpBannerUrls } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/__utils__/useGetBottomSignUpBannerProducts";
import { NonEnglishContent } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/NonEnglishContent";
import * as componentStyles from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BottomSignUpBanner/__internal__/BottomSignUpBannerContent/styles.css";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import isChromatic from "chromatic/isChromatic";
import React from "react";
import { useHistory } from "react-router-dom";
export var BottomSignUpBannerContent = function() {
    var history = useHistory();
    return /*#__PURE__*/ _jsxs(Column, {
        align: "center",
        justify: "center",
        className: componentStyles.contentWrapper,
        children: [
            /*#__PURE__*/ _jsx(BannerContent, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "4x",
                    desktopAndAbove: "5x"
                }
            }),
            /*#__PURE__*/ _jsx(Button, {
                style: {
                    width: "fit-content"
                },
                onClick: function() {
                    return popSignUp(history, SignUpType.GENERIC, function() {
                        return null;
                    }, {
                        element: SignUpElement.BELOW_FOLD,
                        sourceId: "logged_out_homepage_bottom_sign_up_banner"
                    });
                },
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "7jfZHz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign up for free"
                        }
                    ]
                })
            })
        ]
    });
};
var BannerContent = function() {
    var _getLocaleKey;
    var isEnglish = ((_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language) === Language.ENG;
    var isXLargeAndAbove = useViewport().isXLargeAndAbove;
    var bottomSignUpBannerUrls = useGetBottomSignUpBannerUrls();
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var linkPositioning = isXLargeAndAbove ? [
        "329px",
        "361px",
        "316px",
        "370px",
        "364px"
    ] : [
        "0",
        "0",
        "0",
        "0",
        "0"
    ];
    if (!isEnglish) {
        return /*#__PURE__*/ _jsx(NonEnglishContent, {});
    }
    return /*#__PURE__*/ _jsxs(BannerContentTypography, {
        children: [
            /*#__PURE__*/ _jsx(AnimatedWordPerfect, {
                children: "The perfect"
            }),
            bottomSignUpBannerUrls.slice(0, isChromatic() ? 1 : bottomSignUpBannerUrls.length).map(function(content, index) {
                return /*#__PURE__*/ _jsx(RotatingLink, {
                    $index: index,
                    $linkPositioning: linkPositioning,
                    linkTo: content.url,
                    onClick: function() {
                        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("perfect_product_banner-product-link", content.url, "".concat(homepageRedesignVariant));
                    },
                    children: /*#__PURE__*/ _jsx(BannerContentTypography, {
                        style: {
                            color: "unset"
                        },
                        children: content.keyword
                    })
                }, content.keyword);
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsxs(Flex, {
                style: {
                    width: "100%"
                },
                direction: {
                    mobileAndAbove: "column",
                    xLargeAndAbove: "row"
                },
                gap: {
                    mobileAndAbove: 4,
                    xLargeAndAbove: "1x"
                },
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: "for your store, "
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: "right this way."
                    })
                ]
            })
        ]
    });
};
